"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchForm = exports.DEFAULT_FORM = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const branch_types_1 = require("@front/types/branch.types");
exports.DEFAULT_FORM = {
    name: '',
    description: '',
    color: ''
};
//@ts-ignore                
let rwsTemplate = T.html ` <div class="container-fluid">
    <div class="branch-form-page">
      <div class="row">
        <div class="col-lg-8 col-12 pb-lg-5">
          <div class="mb-2">
            <h1>${x => x.branchId ? 'branch.form.title.edit'.t() : 'branch.form.title.add'.t()}</h1>
            <div class="text-zero top-right-button-container">
              <button @click="${(x, c) => x.back()}" type="button"
                class="top-right-button mr-1 btn btn-primary btn-lg">${'branch.form.back'.t()}</button>
            </div>
          </div>
          <div class="card card-body mb-5">
            <the-form :onSubmit="${(x, c) => x.handleSubmit.bind(x)}">
              <div class="form-row">
                <div class="form-group col-md-6">                  
                  <part-input required="true" class="form-part" label="${'branch.form.name.label'.t()}" :value="${x => x.form.name}"
                    name="name" placeholder="${'branch.form.name.placeholder'.t()}" required="true"
                  ></part-input>
                </div>
                <div class="form-group col-md-6">
                  <part-input class="form-part" label="${'branch.form.color.label'.t()}" :value="${x => x.form.color}"
                    name="color" type="color" placeholder="${'branch.form.color.placeholder'.t()}"
                    ></part-input>
                </div>
              </div>
              <div class="form-group">
                <part-textarea class="form-part" label="${'branch.form.description.label'.t()}" :value="${x => x.form.description}"
                  name="description" type="textarea" placeholder="${'branch.form.description.placeholder'.t()}"
                  ></part-textarea>
              </div>            
              <div class="form-group mt-4">
                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                  ?disabled="${x => x.loading}">
                  ${x => x.branchId ? 'branch.form.submit.update'.t() : 'branch.form.submit.create'.t()}
                </button>
              </div>
            </the-form>
          </div>
        </div>
      </div>
    </div>
  </div>`;
require("./styles/layout.scss");
const styles = T.css `.branch-form-page .color-input {
  height: 40px;
}`;
const shadowOptions = { "mode": "open" };
let BranchForm = class BranchForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.branchId = null;
        this.form = exports.DEFAULT_FORM;
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.branchId = this.routeParams.id;
        this.form = {
            name: '',
            description: '',
            color: ''
        };
        if (this.branchId) {
            await this.loadBranch();
        }
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    async loadBranch() {
        var _a;
        if (!this.branchId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('branch.get', {
                routeParams: { id: this.branchId }
            });
            const branch = response.data;
            if (branch) {
                this.form = {
                    name: branch.name,
                    description: branch.description,
                    color: branch.color
                };
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('branch.form.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    back() {
        component_2.SiteMenu.goto.bind(this)('/branch/list');
    }
    async handleSubmit(event) {
        var _a, _b, _c;
        event.preventDefault();
        try {
            this.loading = true;
            let response;
            if (this.branchId) {
                response = await this.apiService.back.put('branch.update', this.form, { routeParams: { id: this.branchId } });
            }
            else {
                response = await this.apiService.back.post('branch.create', this.form);
            }
            if (response && response.success) {
                const successMessage = this.branchId ? 'branch.form.success.updated'.t() : 'branch.form.success.created'.t();
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify(successMessage, 'info');
                if (!this.branchId) {
                    this.form = {
                        name: '',
                        description: '',
                        color: ''
                    };
                }
                component_2.SiteMenu.goto.bind(this)('/branch/list');
            }
            else {
                const actionText = this.branchId ? 'branch.form.action.update'.t() : 'branch.form.action.create'.t();
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify(`${'branch.form.error.action_failed'.t()} ${actionText}`, 'error');
            }
        }
        catch (e) {
            const actionText = this.branchId ? 'branch.form.action.update'.t() : 'branch.form.action.create'.t();
            (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify(`${'branch.form.error.general_error'.t()} ${actionText}`, 'error');
        }
        finally {
            this.loading = false;
        }
    }
};
exports.BranchForm = BranchForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], BranchForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], BranchForm.prototype, "branchId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof branch_types_1.IBranchPayload !== "undefined" && branch_types_1.IBranchPayload) === "function" ? _a : Object)
], BranchForm.prototype, "form", void 0);
exports.BranchForm = BranchForm = __decorate([
    (0, client_1.RWSView)('branch-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], BranchForm);
BranchForm.defineComponent();
